import { IonButtons, IonButton, IonCol, IonGrid, IonContent, IonHeader, IonIcon, IonMenuButton, IonPage, IonRow, IonText, IonTitle, IonToolbar } from '@ionic/react';

const Farmacos = (props) => {

  return (
    <>{(props.lang === 'ES') ?
    <IonPage>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle className='headertitle' style={{ fontSize: "24"}}>Fármacos</IonTitle>
        </IonToolbar>
      <IonContent >
        <IonGrid className="paddingh20  textblack ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">

          <IonRow className="mt2  mx2 mb1 ">
            <table className="farmacos alerta " id="iSGLT2">
              <tr>
                <th align="left"><IonButton color="primary" className="f2">iSGLT2</IonButton></th>
                <th >Dosis de Inicio</th>
                <th >Dosis M&aacute;ximas</th>
              </tr>
              <tr>
                <th align="left">Dapagliflozina</th>      <td>10mg / 24h</td>      <td>10mg / 24h</td>
              </tr>
              <tr>
                <th align="left">Empagliflozina</th>      <td>10mg / 24h</td>      <td>10mg / 24h</td></tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th colSpan="3" align="left">Efectos adversos/ Posibles soluciones</th>
              </tr>
              <tr>
                <td colSpan="3">
                  <dl className="adversos alerta">
                    <dt>Infecciones genitourinarias</dt>
                    <dd>Extremar la higiene.Tratamiento t&oacute;pico local.<br /> Selecci&oacute;n de paciente.<br /></dd>
                    <dt>Cetoacidosis eugluc&eacute;mica</dt>
                    <dd>Suspender.</dd>
                  </dl>
                </td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th align="left" ><IonButton color="primary" className="f1">Beta-Bloqueantes</IonButton></th>
                <th >Dosis de Inicio</th>
                <th >Dosis M&aacute;ximas</th>
              </tr>
              <tr>
                <th align="left">Bisoprolol</th>
                <td>1,25mg / 24h</td>
                <td>10mg / 24h</td>
              </tr>
              <tr>
                <th align="left">Carvedilol</th>
                <td>3,125mg / 12h</td>
                <td>25-50mg / 12h</td>
              </tr>
              <tr>
                <th align="left">Metoprolol succinato</th>
                <td>12,5-25mg / 24h</td>
                <td>200mg / 24h</td>
              </tr>
              <tr>
                <th align="left">Nebivolol</th>
                <td>1,25mg / 24h</td>
                <td>10mg / 24h</td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th colSpan="3" align="left">Efectos adversos/ Posibles soluciones</th>
              </tr>
              <tr>
                <td colSpan="3">
                  <dl className="adversos alerta">
                    <dt>Bradicardia/hipotensi&oacute;n</dt>
                    <dd>Reducir dosis seg&uacute;n la cl&iacute;nica</dd>
                    <dt>Broncospasmo</dt>
                    <dd>Sustituir por B1 selectivo</dd>
                    <dt>Disfunci&oacute;n er&eacute;ctil</dt>
                    <dd>Cambiar de f&aacute;rmaco. Asociar inhibidores de la fosfodiesterasa</dd>
                    <dt>Astenia</dt>
                    <dd>Escalada de dosis lenta</dd>
                    <dt>Raynaud</dt>
                    <dd>Medidas f&iacute;sicas.</dd>
                    <dt>Enmascaramiento de hipoglucemias</dt>
                    <dd>Especialmente en el anciano fr&aacute;gil, reducir dosis.</dd>
                  </dl>
                </td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th align="left" ><IonButton color="primary" className="f2">ARM</IonButton></th>
                <th >Dosis de Inicio</th>
                <th >Dosis M&aacute;ximas</th>
              </tr>
              <tr>
                <th align="left">Espironolactona</th>
                <td>25mg / 24h</td>
                <td>50mg / 24h</td>
              </tr>
              <tr>
                <th align="left">Eplerenona</th>
                <td>25mg / 24h</td>
                <td>50mg / 24h</td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th colSpan="3" align="left">Efectos adversos/ Posibles soluciones</th>
              </tr>
              <tr>
                <td colSpan="3">
                  <dl className="adversos alerta">
                    <dt>Ginecomastia</dt>
                    <dd>Cambiar a eplerenona</dd>
                    <dt>Hiperpotasemia</dt>
                    <dd>Reducir dosis o suspender</dd>
                    <dt>Deterioro TFG</dt>
                    <dd>Reducir dosis o suspender</dd>
                  </dl>
                </td>
              </tr>

              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th align="left" ><IonButton color="primary" className="f2">INRA</IonButton></th>
                <th >Dosis de Inicio</th>
                <th >Dosis M&aacute;ximas</th>
              </tr>
              <tr>
                <th align="left">Sacubitril / Valsart&aacute;n</th>
                <td>24/26mg / 12h</td>
                <td>97/103mg / 12h</td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th colSpan="3" align="left">Efectos adversos/ Posibles soluciones</th>
              </tr>
              <tr>
                <td colSpan="3">
                  <dl className="adversos alerta">

                    <dt>Hipotensi&oacute;n</dt>
                    <dd>Ajustar dosis y separar de otros hipotensores</dd>
                    <dt>Hiperpotasemia</dt>
                    <dd>Reducir dosis si el K est&aacute; entre 5,1 y 6 mEq/l<br />Suspender si el K &gt;6 mEq/l</dd>
                  </dl>
                </td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th align="left" ><IonButton color="primary" className="f2">IECAs</IonButton></th>
                <th >Dosis de Inicio</th>
                <th >Dosis M&aacute;ximas</th>
              </tr>
              <tr>
                <th align="left">Captopril</th>
                <td>6,25mg / 8h</td>
                <td>50mg / 8h</td>
              </tr>
              <tr>
                <th align="left">Enalapril</th>
                <td>2,5mg / 12h</td>
                <td>20mg / 12h</td>
              </tr>
              <tr>
                <th align="left">Lisinopril</th>
                <td>2,5-5 mg / 24h</td>
                <td>20-40 mg / 24h</td>
              </tr>
              <tr>
                <th align="left">Ramipril</th>
                <td>2,5mg / 24h</td>
                <td>10mg / 24h</td>
              </tr>
              <tr>
                <th align="left">Trandolapril</th>
                <td>0,5mg / 24h</td>
                <td>4mg / 24h</td>
              </tr>
              <tr>
                <th align="left">Quinapril</th>
                <td>5mg / 12h</td>
                <td>20mg / 12h</td>
              </tr>
              <tr>
                <th align="left">Fosinopril</th>
                <td>5-10mg / 24h</td>
                <td>40 mg / 24h</td>
              </tr>
              <tr>
                <th align="left">Perindopril</th>
                <td>2mg / 24 h</td>
                <td>8-16mg / 24h</td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th colSpan="3" align="left">Efectos adversos/ Posibles soluciones</th>
              </tr>
              <tr>
                <td colSpan="3">
                  <dl className="adversos alerta">
                    <dt>Hiperpotasemia</dt>
                    <dd>Reducir dosis si K est&aacute; entre 5,1-5,9 mEq/l.<br /> Suspender si el K&gt;6 mEq/l.</dd>
                    <dt>Deterioro del filtrado glomerular</dt>
                    <dd>Reducir dosis. Suspender si la creatinina &gt;3 mg/dl o &gt;50% de la basal.</dd>
                    <dt>Angioedema</dt>
                    <dd>Suspender.</dd>
                    <dt>Tos seca</dt>
                    <dd>Cambiar IECA por ARA II.</dd>
                  </dl>
                </td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th align="left" ><IonButton color="primary" className="f2">ARAII</IonButton></th>
                <th >Dosis de Inicio</th>
                <th >Dosis M&aacute;ximas</th>
              </tr>
              <tr>
                <th align="left">Losart&aacute;n</th>
                <td>25-50mg / 24h</td>
                <td>100-150mg / 24h</td>
              </tr>
              <tr>
                <th align="left">Valsart&aacute;n</th>
                <td>40mg / 12h</td>
                <td>160mg / 12h</td>
              </tr>
              <tr>
                <th align="left">Candesart&aacute;n</th>
                <td>4-8mg / 24h</td>
                <td>32mg / 24h</td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th colSpan="3" align="left">Efectos adversos/ Posibles soluciones</th>
              </tr>
              <tr>
                <td colSpan="3">
                  <dl className="adversos alerta">
                    <dt>Hipotensi&oacute;n</dt>
                    <dd>Ajustar dosis y separar de otros hipotensores.</dd>
                  </dl>
                </td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th align="left" ><IonButton color="primary" className="f2">DIU</IonButton></th>
                <th >Dosis de Inicio</th>
                <th >Dosis M&aacute;ximas</th>
              </tr>
              <tr>
                <th align="left">Furosemida</th>
                <td>20mg / 24h</td>
                <td>80mg / 8h</td>
              </tr>
              <tr>
                <th align="left">Torasemida</th>
                <td>5mg / 24h</td>
                <td>20mg / 8h</td>
              </tr>
              <tr>
                <th align="left">Bumetadina</th>
                <td>0,5-1mg / 24h</td>
                <td>5mg / 24h</td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th colSpan="3" align="left">Efectos adversos/ Posibles soluciones</th>
              </tr>
              <tr>
                <td colSpan="3">
                  <dl className="adversos alerta">
                    <dt>Pancitopenia:</dt><dd> Suspender</dd>
                    <dt>Hipopotasemia:</dt><dd> Suplementos de K. Asociar diur&eacute;tico ahorrador de K</dd>
                    <dt>Hiponatremia:</dt><dd> Ajustar dosis. Restricci&oacute;n l&iacute;quidos.</dd>
                    <dt>Hiperglucemia:</dt><dd> Reducir dosis.</dd>
                  </dl>
                </td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th align="left" ><IonButton color="primary" className="f2">Tiazidas</IonButton></th>
                <th >Dosis de Inicio</th>
                <th >Dosis M&aacute;ximas</th>
              </tr>
              <tr>
                <th align="left">Hidroclorotiazida</th>
                <td>12,5 mg/24 h</td>
                <td>50 mg/12 h</td>
              </tr>
              <tr>
                <th align="left">Indapamida</th>
                <td>2,5 mg/24 h</td>
                <td>5 mg/24 h</td>
              </tr>
              <tr>
                <th align="left">Clortalidona</th>
                <td>25-50 mg/24 h</td>
                <td>100 mg/24 h</td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
              <tr>
                <th colSpan="3" align="left">Efectos adversos/ Posibles soluciones</th>
              </tr>
              <tr>
                <td colSpan="3">
                  <dl className="adversos alerta">
                    <dt>Hiperuricemia:</dt><dd> Asociar alopurinol</dd>
                    <dt>Hiperglucemia:</dt>
                  </dl>
                </td>
              </tr>
              <tr><td colSpan="3"> </td></tr>
            </table>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
    :
    <IonPage>
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton />
        </IonButtons>
        <IonTitle className='headertitle' style={{ fontSize: "24"}}>Drugs</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent >
      <IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">

        <IonRow className="mt2  mx2 mb1 ">
          <table className="farmacos alerta " id="iSGLT2">
            <tr>
              <th align="left"><IonButton color="primary" className="f2">SGLT2i</IonButton></th>
              <th >Starting Dose</th>
              <th >Maximum dose</th>
            </tr>
            <tr>
              <th align="left">Dapagliflozin</th>      <td>10mg / 24h</td>      <td>10mg / 24h</td>
            </tr>
            <tr>
              <th align="left">Empagliflozin</th>      <td>10mg / 24h</td>      <td>10mg / 24h</td></tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th colSpan="3" align="left">Adverse effects/ Possible solutions</th>
            </tr>
            <tr>
              <td colSpan="3">
                <dl className="adversos alerta">
                  <dt>Genitourinary infections</dt>
                  <dd>Extreme hygiene. Local topical treatment.<br /> Patient selection.<br /></dd>
                  <dt>Euglycemic ketoacidosis</dt>
                  <dd>Lay off.</dd>
                </dl>
              </td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th align="left" ><IonButton color="primary" className="f1">Beta Blockers</IonButton></th>
              <th >Starting Dose</th>
              <th >Maximum dose</th>
            </tr>
            <tr>
              <th align="left">Bisoprolol</th>
              <td>1,25mg / 24h</td>
              <td>10mg / 24h</td>
            </tr>
            <tr>
              <th align="left">Carvedilol</th>
              <td>3,125mg / 12h</td>
              <td>25-50mg / 12h</td>
            </tr>
            <tr>
              <th align="left">Metoprolol succinate</th>
              <td>12,5-25mg / 24h</td>
              <td>200mg / 24h</td>
            </tr>
            <tr>
              <th align="left">Nebivolol</th>
              <td>1,25mg / 24h</td>
              <td>10mg / 24h</td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th colSpan="3" align="left">Adverse effects/ Possible solutions</th>
            </tr>
            <tr>
              <td colSpan="3">
                <dl className="adversos alerta">
                  <dt>Bradycardia/hypotension</dt>
                  <dd>Reduce dose according to clinical</dd>
                  <dt>Bronchospasm</dt>
                  <dd>Replace with selective B1</dd>
                  <dt>Erectile dysfunction</dt>
                  <dd>Change drug. Associate phosphodiesterase inhibitors</dd>
                  <dt>Asthenia</dt>
                  <dd>Slow dose escalation</dd>
                  <dt>Raynaud</dt>
                  <dd>Physical measurements.</dd>
                  <dt>Masking of hypoglycemia</dt>
                  <dd>Especially in the frail elderly, reduce dose.</dd>
                </dl>
              </td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th align="left" ><IonButton color="primary" className="f2">MRA</IonButton></th>
              <th >Starting Dose</th>
              <th >Maximum dose</th>
            </tr>
            <tr>
              <th align="left">Spironolactone</th>
              <td>25mg / 24h</td>
              <td>50mg / 24h</td>
            </tr>
            <tr>
              <th align="left">Eplerenone</th>
              <td>25mg / 24h</td>
              <td>50mg / 24h</td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th colSpan="3" align="left">Adverse effects/ Possible solutions</th>
            </tr>
            <tr>
              <td colSpan="3">
                <dl Gynecomastia="adversos alerta">
                  <dt>Ginecomastia</dt>
                  <dd>Switch to Eplerenone</dd>
                  <dt>Hyperkalaemia</dt>
                  <dd>Reduce dose or discontinue</dd>
                  <dt>GFR deterioration</dt>
                  <dd>Reduce dose or discontinue</dd>
                </dl>
              </td>
            </tr>

            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th align="left" ><IonButton color="primary" className="f2">ARNI</IonButton></th>
              <th >Starting Dose</th>
              <th >Maximum dose</th>
            </tr>
            <tr>
              <th align="left">Sacubitril / Valsart&aacute;n</th>
              <td>24/26mg / 12h</td>
              <td>97/103mg / 12h</td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th colSpan="3" align="left">Adverse effects/ Possible solutions</th>
            </tr>
            <tr>
              <td colSpan="3">
                <dl className="adversos alerta">

                  <dt>Hypotension</dt>
                  <dd>Adjust dose and separate from other hypotensives</dd>
                  <dt>Hyperkalaemia</dt>
                  <dd>Reduce dose if K is between 5.1 and 6 mEq/l <br />Discontinue if K &gt; 6 mEq/l</dd>
                </dl>
              </td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th align="left" ><IonButton color="primary" className="f2">ACEI</IonButton></th>
              <th >Starting Dose</th>
              <th >Maximum dose</th>
            </tr>
            <tr>
              <th align="left">Captopril</th>
              <td>6,25mg / 8h</td>
              <td>50mg / 8h</td>
            </tr>
            <tr>
              <th align="left">Enalapril</th>
              <td>2,5mg / 12h</td>
              <td>20mg / 12h</td>
            </tr>
            <tr>
              <th align="left">Lisinopril</th>
              <td>2,5-5 mg / 24h</td>
              <td>20-40 mg / 24h</td>
            </tr>
            <tr>
              <th align="left">Ramipril</th>
              <td>2,5mg / 24h</td>
              <td>10mg / 24h</td>
            </tr>
            <tr>
              <th align="left">Trandolapril</th>
              <td>0,5mg / 24h</td>
              <td>4mg / 24h</td>
            </tr>
            <tr>
              <th align="left">Quinapril</th>
              <td>5mg / 12h</td>
              <td>20mg / 12h</td>
            </tr>
            <tr>
              <th align="left">Fosinopril</th>
              <td>5-10mg / 24h</td>
              <td>40 mg / 24h</td>
            </tr>
            <tr>
              <th align="left">Perindopril</th>
              <td>2mg / 24 h</td>
              <td>8-16mg / 24h</td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th colSpan="3" align="left">Adverse effects/ Possible solutions</th>
            </tr>
            <tr>
              <td colSpan="3">
                <dl className="adversos alerta">
                  <dt>Hyperkalaemia</dt>
                  <dd>Reduce dose if K is between 5.1-5.9 mEq/l.<br /> Discontinue if K&gt;6 mEq/l.</dd>
                  <dt>Impaired glomerular filtration</dt>
                  <dd>Reduce dose. Discontinue if creatinine &gt;3 mg/dl or &gt;50% of baseline</dd>
                  <dt>Angioedema</dt>
                  <dd>Lay off.</dd>
                  <dt>Dry cough</dt>
                  <dd>Change ACEI for AIIRA.</dd>
                </dl>
              </td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th align="left" ><IonButton color="primary" className="f2">AIIRA</IonButton></th>
              <th >Starting Dose</th>
              <th >Maximum dose</th>
            </tr>
            <tr>
              <th align="left">Losart&aacute;n</th>
              <td>25-50mg / 24h</td>
              <td>100-150mg / 24h</td>
            </tr>
            <tr>
              <th align="left">Valsart&aacute;n</th>
              <td>40mg / 12h</td>
              <td>160mg / 12h</td>
            </tr>
            <tr>
              <th align="left">Candesart&aacute;n</th>
              <td>4-8mg / 24h</td>
              <td>32mg / 24h</td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th colSpan="3" align="left">Adverse effects/ Possible solutions</th>
            </tr>
            <tr>
              <td colSpan="3">
                <dl className="adversos alerta">
                  <dt>Hypotension</dt>
                  <dd>Adjust dose and separate from other hypotensives.</dd>
                </dl>
              </td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th align="left" ><IonButton color="primary" className="f2">DIU</IonButton></th>
              <th >Starting Dose</th>
              <th >Maximum dose</th>
            </tr>
            <tr>
              <th align="left">Furosemide</th>
              <td>20mg / 24h</td>
              <td>80mg / 8h</td>
            </tr>
            <tr>
              <th align="left">Torasemide</th>
              <td>5mg / 24h</td>
              <td>20mg / 8h</td>
            </tr>
            <tr>
              <th align="left">Bumetadine</th>
              <td>0,5-1mg / 24h</td>
              <td>5mg / 24h</td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th colSpan="3" align="left">Adverse effects/ Possible solutions</th>
            </tr>
            <tr>
              <td colSpan="3">
                <dl className="adversos alerta">
                  <dt>Pancytopenia:</dt><dd> Lay off</dd>
                  <dt>Hypokalemia:</dt><dd> K supplements. Associate K-sparing diuretic.</dd>
                  <dt>Hyponatremia:</dt><dd> Adjust dose. Liquid restriction.</dd>
                  <dt>Hyperglycemia:</dt><dd> Reduce dose.</dd>
                </dl>
              </td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th align="left" ><IonButton color="primary" className="f2">Thiazides</IonButton></th>
              <th >Starting Dose</th>
              <th >Maximum dose</th>
            </tr>
            <tr>
              <th align="left">Hydrochlorothiazide</th>
              <td>12,5 mg/24 h</td>
              <td>50 mg/12 h</td>
            </tr>
            <tr>
              <th align="left">Indapamide</th>
              <td>2,5 mg/24 h</td>
              <td>5 mg/24 h</td>
            </tr>
            <tr>
              <th align="left">Chlorthalidone</th>
              <td>25-50 mg/24 h</td>
              <td>100 mg/24 h</td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
            <tr>
              <th colSpan="3" align="left">Adverse effects/ Possible solutions</th>
            </tr>
            <tr>
              <td colSpan="3">
                <dl className="adversos alerta">
                  <dt>Hyperuricemia:</dt><dd> Associate allopurinol</dd>
                  <dt>Hyperglycemia:</dt>
                </dl>
              </td>
            </tr>
            <tr><td colSpan="3"> </td></tr>
          </table>
        </IonRow>
      </IonGrid>
    </IonContent>
  </IonPage>
}</>
  );
};

export default Farmacos;
